module.exports = __webpack_public_path__ + "img/deskshelf10.c966d94d.jpg";